import { createContext, useContext, useEffect, useState } from "react";
import appUrl from "../appUrl";
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

export const AuthContext = createContext();

const appurl = appUrl();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem("token") || null);
    const [loggedUser, setLoggedUser] = useState({
        name: "",
        image: null,
    });
    // const [isLoggedIn, setIsLoggedIn] = useState(() => localStorage.getItem('isLoggedIn') === 'true');
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
        return storedIsLoggedIn ? JSON.parse(storedIsLoggedIn) : false;
    });
    const authorizationToken = `Bearer ${token}`

    const storeTokenInLS = async (serverToken) => {
        localStorage.setItem('token', serverToken);
        setToken(serverToken);
        console.log("Token stored", serverToken);
        setIsLoggedIn(true);
    };
    localStorage.setItem("isLoggedIn", isLoggedIn)

    console.log(loggedUser, "Logged user data");


    useEffect(() => {
        const originalFetch = window.fetch;

        window.fetch = async (...args) => {
            const response = await originalFetch(...args);

            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.setItem('isLoggedIn', false);
                window.location.href = '/';
            }

            return response;
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);


    return (
        <>
            <AuthContext.Provider value={{ isLoggedIn, storeTokenInLS, loggedUser, setLoggedUser, authorizationToken, setIsLoggedIn }}>
                {children}
            </AuthContext.Provider>
            <NotificationContainer />
        </>
    );
};

export const useAuth = () => {
    const authContext = useContext(AuthContext);

    if (!authContext) {
        throw new Error("useAuth must be used within an AuthProvider");
    }

    return authContext;
};
